import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { Star, Truck, Minus, Plus } from "lucide-react";
import { api } from "../lib/api";
import { useStore } from "../context/Store";
import { ProductCard } from "../components/ProductCard";
import { Reviews } from "../components/Reviews";

export default function ProductPage() {
  const { id } = useParams();
  const [p, setP] = useState(null);
  const [qty, setQty] = useState(1);
  const { fmt, addToCart } = useStore();
  useEffect(() => { setP(null); setQty(1); api.get(`/products/${id}`).then((r) => setP(r.data)); window.scrollTo(0, 0); }, [id]);
  if (!p) return <div className="max-w-7xl mx-auto px-6 py-16"><div className="h-96 rounded-3xl bg-stone-200 animate-pulse" /></div>;
  const off = p.original_price_usd > p.price_usd ? Math.round((1 - p.price_usd / p.original_price_usd) * 100) : 0;
  return (
    <div className="max-w-7xl mx-auto px-6 py-10" data-testid="product-page">
      <div className="grid md:grid-cols-2 gap-10">
        <div className="rounded-3xl overflow-hidden bg-white border border-[#C85A32]/10">
          <img src={p.image.replace(/_\d+x\d+\.\w+$/, "")} alt={p.title} className="w-full aspect-square object-cover" data-testid="product-image" />
        </div>
        <div>
          <span className="text-xs uppercase tracking-[0.25em] font-bold text-[#C85A32]">{p.category}</span>
          <h1 className="font-display text-2xl sm:text-3xl font-extrabold mt-3 leading-tight" data-testid="product-title">{p.title}</h1>
          <div className="flex items-center gap-2 mt-3 text-sm text-stone-500">
            <Star className="w-4 h-4 fill-[#D99B26] text-[#D99B26]" /> {p.rating?.toFixed(1)} · {p.sold || "New arrival"}
          </div>
          <div className="flex items-baseline gap-3 mt-6">
            <span className="font-display text-4xl font-extrabold" data-testid="product-price">{fmt(p.price_usd)}</span>
            {off > 0 && <><span className="line-through text-stone-400">{fmt(p.original_price_usd)}</span><span className="text-sm font-bold text-[#C85A32]">Save {off}%</span></>}
          </div>
          <p className="text-sm text-[#1E5E3A] mt-2 font-semibold">{p.stock} in stock</p>
          <div className="flex items-center gap-4 mt-8">
            <div className="flex items-center gap-3 bg-white border rounded-full px-2 h-12">
              <button data-testid="product-qty-dec" onClick={() => setQty(Math.max(1, qty - 1))} className="w-8 h-8 grid place-items-center"><Minus className="w-4 h-4" /></button>
              <span className="w-6 text-center font-semibold" data-testid="product-qty">{qty}</span>
              <button data-testid="product-qty-inc" onClick={() => setQty(Math.min(50, qty + 1))} className="w-8 h-8 grid place-items-center"><Plus className="w-4 h-4" /></button>
            </div>
            <button data-testid="product-add-to-cart-btn" onClick={() => addToCart(p, qty)} className="flex-1 h-12 rounded-full bg-[#C85A32] text-white font-semibold hover:bg-[#A9481F] active:scale-[0.98] transition-[background-color,transform]">Add to basket</button>
          </div>
          <div className="mt-8 p-5 rounded-2xl bg-[#1E5E3A]/5 border border-[#1E5E3A]/15 flex gap-3 text-sm">
            <Truck className="w-5 h-5 text-[#1E5E3A] shrink-0" />
            <div><p className="font-semibold">Delivery across Africa in 10–20 days</p><p className="text-stone-500">Free delivery on orders over $50. Pay with M-Pesa, EcoCash, MoMo, PayPal or card.</p></div>
          </div>
        </div>
      </div>
      <Reviews pid={p.id} />
      {p.related?.length > 0 && (
        <section className="mt-20">
          <h2 className="font-display text-2xl font-extrabold">You may also like</h2>
          <div className="grid grid-cols-2 sm:grid-cols-4 gap-4 mt-6">{p.related.map((r) => <ProductCard key={r.id} p={r} />)}</div>
        </section>
      )}
    </div>
  );
}
